export const msalConfig = {
  auth: {
    clientId: '3a99b67d-1abc-423f-9ba6-98d8dc2eace6', // This is the ONLY mandatory field that you need to supply.
    authority: 'https://milrosecp.b2clogin.com/milrosecp.onmicrosoft.com/B2C_1_signupsignin1', // Choose SUSI as your default authority.
    knownAuthorities: ['milrosecp.b2clogin.com'], // Mark your B2C tenant's domain as trusted.
    // redirectUri: 'http://localhost:3000/', //'https://gentle-wave-0828d220f.6.azurestaticapps.net/', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    // postLogoutRedirectUri: 'https://gentle-wave-0828d220f.6.azurestaticapps.net/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If 'true', will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'sessionStorage', // Configures cache location. 'sessionStorage' is more secure, but 'localStorage' gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to 'true' if you are having issues on IE11 or Edge
  }
}